import React from "react";
import { Container } from "./styles";
import icon from "../../../assets/images/svg-CheckCo.svg";

function GerenciamentoCad() {
  return (
    <Container>
      <h1>Em Breve</h1>
      <p>Aguarde pelas proximas Atualizações</p>
      <img src={icon} alt="corretor_img" />
    </Container>
  );
}

export default GerenciamentoCad;
